// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"ea263ad9","453":"efa25bda"}[chunkId] + ".chunk.js";
};